module.exports = __webpack_public_path__ + "img/20191202173732012.ba69655d.jpg";